// extracted by mini-css-extract-plugin
export default {"seoBlockLinkList":"c-a_hh"};